import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { assets } from '@pukka/common';
import { Button, Text } from '@pukka/ui-components';
import { useVariantWithFallback } from '@pukka/unleash';
import DOMPurify from 'dompurify';
import { marked } from 'marked';

import mokaPcSplash from './assets/moka-pc-splash.png';

function getUnsafeHTMLContent(content: string) {
  const markdown = DOMPurify.sanitize(marked.parse(content) as string);

  return { __html: markdown };
}

function MokaPcPage() {
  const [enableDownload] = useVariantWithFallback('backoffice-download-moka-pc');
  const { t } = useTranslation();

  const urlValue: Record<string, string> | undefined = useMemo(() => {
    return enableDownload?.enabled && enableDownload.payload?.type === 'json' && JSON.parse(enableDownload.payload.value);
  }, [enableDownload]);

  const { appUrl, guideUrl, printerDriverUrl, printerDriverSteps } = urlValue || {};

  const handleClickDownload = (url: string) => {
    window.open(url);
  };

  return (
    <div className="h-screen w-screen overflow-auto bg-neutral-200">
      <header className="flex h-14 w-full items-center justify-between bg-legacy-500 px-4">
        <div className="mx-auto flex w-[1000px] items-center justify-between ">
          <a href="/">
            <img alt="Moka logo" width={40} height={40} src={assets.logoMoka} />
          </a>
          <div className="flex items-center gap-6">
            <a
              href="https://help.mokapos.com/s/?language=in"
              target="_blank"
              className="text-neutral-400 hover:text-white"
              rel="noreferrer"
            >
              {t('common.helpButton')}
            </a>
          </div>
        </div>
      </header>
      <div className="flex items-center justify-center bg-neutral-200 py-10">
        <div className="">
          <div className="flex max-w-[1000px] items-center gap-5 rounded-xl bg-white px-12 py-16 ">
            <div className="flex flex-1 flex-col gap-4">
              <div>
                <Text variant="heading-2" weight="bold">
                  Moka POS for Windows
                </Text>
                <Text variant="subtitle-1">Satu Aplikasi POS untuk Semua Kebutuhan Bisnis</Text>
              </div>

              <div>
                <Button size="xl" reverse icon="download" disabled={!appUrl} onClick={() => handleClickDownload(appUrl)}>
                  Download Now
                </Button>
              </div>

              <div>
                {guideUrl && (
                  <div>
                    <Button size="s" variant="nude-blue" onClick={() => handleClickDownload(guideUrl)}>
                      Download guide
                    </Button>
                  </div>
                )}
              </div>
            </div>

            <div className="flex-1">
              <img src={mokaPcSplash} className="rounded-xl" alt="moka splash screen" />
            </div>
          </div>

          <br />

          <div className="rounded-xl bg-white px-12 py-16 ">
            <Text variant="title-2" weight="bold">
              Menghubungkan Printer ke PC
            </Text>
            <div className="flex">
              <div className="flex-1 pt-2">
                <Button onClick={() => handleClickDownload(printerDriverUrl)}>Download printer driver (Zadig)</Button>
              </div>
              <div className="flex-1">
                <Text weight="semibold">Langkah</Text>
                <div dangerouslySetInnerHTML={getUnsafeHTMLContent(printerDriverSteps || '')} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { MokaPcPage };
